module.exports = __webpack_public_path__ + "static/img/celoscope-detail-9.3cdfe58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-9.jpg
// module id = JlIU
// module chunks = 52